import { useLang } from "@/contexts/LangContext";
import SectionReveal from "@/components/SectionReveal";

const TEA_IMG =
  "https://images.unsplash.com/photo-1531969179221-3946e6b5a5e7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHx0cmFkaXRpb25hbCUyMGNoaW5lc2UlMjB0ZWElMjBjZXJlbW9ueSUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzgwNDc5NDI2fDA&ixlib=rb-4.1.0&q=85";

const INK_TEX =
  "https://images.unsplash.com/photo-1684871430772-569936b1a0ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxjaGluZXNlJTIwdHJhZGl0aW9uYWwlMjBpbmslMjBwYWludGluZyUyMGxhbmRzY2FwZXxlbnwwfHx8fDE3ODA0Nzk0MjZ8MA&ixlib=rb-4.1.0&q=85";

const Culture = () => {
  const { t } = useLang();

  return (
    <section
      id="culture"
      data-testid="culture-section"
      className="relative bg-[#EAE6DF] py-24 md:py-32 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.07] bg-cover bg-center pointer-events-none"
        style={{ backgroundImage: `url(${INK_TEX})` }}
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <SectionReveal className="lg:col-span-5">
            <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-[#2E5D4B] font-semibold mb-4">
              ✦ {t.culture.eyebrow}
            </p>
            <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#121212] leading-[1.05]">
              {t.culture.title}
            </h2>
            <p className="mt-8 text-lg leading-relaxed text-[#4A4A4A]">
              {t.culture.intro}
            </p>
            <div className="mt-10 aspect-[4/5] overflow-hidden">
              <img
                src={TEA_IMG}
                alt="Traditional Chinese tea ceremony"
                className="w-full h-full object-cover transition-transform duration-[1500ms] hover:scale-105"
              />
            </div>
          </SectionReveal>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-6 md:gap-8">
            {t.culture.pillars.map((p, i) => (
              <SectionReveal
                key={p.name}
                delay={i * 0.1}
                data-testid={`culture-pillar-${i}`}
                className="group bg-[#F7F5F0] border border-black/5 p-8 md:p-10 hover:border-[#C62828]/30 transition-colors duration-500"
              >
                <div className="font-heading text-5xl md:text-6xl text-[#C62828]/15 group-hover:text-[#C62828]/30 transition-colors duration-500">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <h3 className="mt-4 font-heading text-2xl md:text-3xl text-[#121212]">
                  {p.name}
                </h3>
                <p className="mt-4 text-[#4A4A4A] leading-relaxed">{p.body}</p>
              </SectionReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Culture;
